import { inputAdornmentClasses as e, inputBaseClasses as a } from "@mui/material";
const n = {
  styleOverrides: {
    root: ({ theme: s }) => ({
      ...s.typography.body1,
      "&&": {
        borderRadius: "8px"
      },
      [`&, .${e.root}`]: {
        background: s.palette.background.level1
      },
      [`.${a.input}`]: {
        paddingBlock: "16px",
        [`&.${a.inputSizeSmall}`]: {
          paddingBlock: "8px"
        }
      },
      fieldset: {
        legend: {
          span: {
            fontSize: "12px",
            "+ span": {
              fontSize: "9px"
            }
          }
        }
      }
    })
  }
}, r = {
  styleOverrides: {
    root: ({ ownerState: s, theme: t }) => ({
      ...t.typography.body1,
      ...s.variant === "outlined" && Object.assign(
        {
          transform: "translate(14px, 16px) scale(1)"
        },
        s.size === "small" && {
          transform: "translate(16px, 8px) scale(1)"
        },
        s.shrink && {
          transform: "translate(16px, -9px) scale(0.75)"
        }
      )
    })
  }
};
export {
  n as inputBase,
  r as inputLabel
};
//# sourceMappingURL=inputBase.mjs.map
